module.exports = __webpack_public_path__ + "static/media/Healthrix.abc18079.png";